export * from './app-breadcrumbs.component';



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/components/app-breadcrumbs/index.ts